var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-data-table', _vm._b({
    attrs: {
      "show-select": "",
      "single-select": "",
      "item-key": "tempId",
      "checkbox-color": "primary",
      "hide-default-footer": "",
      "disable-filtering": "",
      "disable-sort": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function () {
        return [_c('v-divider', {
          staticClass: "border-2 primary"
        })];
      },
      proxy: true
    }, {
      key: `item.type`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-select', {
          class: `form-questions-item-type-${_vm.className}-${item.tempId.toString().slice(2)}`,
          attrs: {
            "items": _vm.types,
            "disabled": !!item._id,
            "menuProps": {
              attach: `.form-questions-item-type-${_vm.className}-${item.tempId.toString().slice(2)}`
            },
            "outlined": "",
            "attach": ""
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.type,
            callback: function ($$v) {
              _vm.$set(item, "type", $$v);
            },
            expression: "item.type"
          }
        }), item.type == _vm.RECRUITMENT_QUESTION_TYPES.MULTIPLE_CHOICE.value ? _c('v-checkbox', {
          attrs: {
            "label": "복수선택",
            "outlined": "",
            "color": "primary"
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.isMultipleSelect,
            callback: function ($$v) {
              _vm.$set(item, "isMultipleSelect", $$v);
            },
            expression: "item.isMultipleSelect"
          }
        }) : _vm._e()];
      }
    }, {
      key: `item.subject`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('v-text-field', {
          staticClass: "subject-field my-12",
          attrs: {
            "outlined": ""
          },
          on: {
            "input": _vm.emit
          },
          scopedSlots: _vm._u([{
            key: "prepend-inner",
            fn: function () {
              return [_vm._v("질문 : ")];
            },
            proxy: true
          }], null, true),
          model: {
            value: item.subject,
            callback: function ($$v) {
              _vm.$set(item, "subject", $$v);
            },
            expression: "item.subject"
          }
        }), item.type == _vm.RECRUITMENT_QUESTION_TYPES.MULTIPLE_CHOICE.value ? [_c('v-combobox', {
          staticClass: "choices-field my-12",
          attrs: {
            "outlined": "",
            "multiple": "",
            "append-icon": "",
            "placeholder": "항목을 적고 Enter를 눌러 추가하세요"
          },
          on: {
            "input": _vm.emit
          },
          scopedSlots: _vm._u([{
            key: "prepend-inner",
            fn: function () {
              return [_vm._v("선택지 : ")];
            },
            proxy: true
          }, {
            key: "selection",
            fn: function (_ref3) {
              var item = _ref3.item,
                parent = _ref3.parent;
              return [_c('draggable', {
                on: {
                  "input": _vm.emit
                },
                model: {
                  value: item.choices,
                  callback: function ($$v) {
                    _vm.$set(item, "choices", $$v);
                  },
                  expression: "item.choices"
                }
              }, [_c('v-chip', {
                staticClass: "mb-6 mb-10",
                attrs: {
                  "small": "",
                  "close": "",
                  "color": "grey-ec"
                },
                on: {
                  "click:close": function ($event) {
                    return parent.selectItem(item);
                  }
                }
              }, [_vm._v(_vm._s(item))])], 1)];
            }
          }], null, true),
          model: {
            value: item.choices,
            callback: function ($$v) {
              _vm.$set(item, "choices", $$v);
            },
            expression: "item.choices"
          }
        })] : _vm._e()];
      }
    }, {
      key: `item.actions`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('v-btn', {
          staticClass: "u-pink ma-auto",
          attrs: {
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.remove(item);
            }
          }
        }, [_c('i', {
          staticClass: "icon icon-minus"
        })])];
      }
    }, {
      key: "foot",
      fn: function () {
        return [_c('tfoot', [_c('td', {
          attrs: {
            "colspan": _vm.headers.length + 1
          }
        }, [_c('v-divider'), _c('v-layout', {
          staticClass: "mt-10"
        }, [_c('v-btn', {
          attrs: {
            "disabled": _vm.upDisabled,
            "icon": "",
            "text": "",
            "x-small": ""
          },
          on: {
            "click": _vm.upItem
          }
        }, [_c('v-icon', {
          staticClass: "font-size-28 mr-4"
        }, [_vm._v(" mdi-chevron-up ")])], 1), _c('v-btn', {
          attrs: {
            "disabled": _vm.downDisabled,
            "icon": "",
            "text": "",
            "x-small": ""
          },
          on: {
            "click": _vm.downItem
          }
        }, [_c('v-icon', {
          staticClass: "font-size-28"
        }, [_vm._v(" mdi-chevron-down ")])], 1)], 1), _c('v-btn', {
          staticClass: "v-btn--plus rounded-lg",
          attrs: {
            "block": "",
            "color": "grey-f8"
          },
          on: {
            "click": _vm.addAnItem
          }
        }, [_c('i', {
          staticClass: "icon icon-plus-sm"
        })])], 1)])];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }